<svg xmlns="http://www.w3.org/2000/svg" width="1" height="30" viewBox="0 0 1 30">
	<line
		id="Línea_167"
		data-name="Línea 167"
		y2="30"
		transform="translate(0.5)"
		fill="none"
		stroke="#bababa"
		stroke-width="1"
	/>
</svg>
